import { TabOptions } from "../../types/fieldInstance.interface";

export const stages = [
  {
    label: TabOptions.PatientDemographics,
    path: "patient-demographics",
  },
  {
    label: TabOptions.Details,
    path: "details",
  },
  {
    label: TabOptions.Factors,
    path: "factors",
  },
  {
    label: TabOptions.Statements,
    path: "statements",
  },
  {
    label: TabOptions.Response,
    path: "response",
  },
  {
    label: TabOptions.Conclusion,
    path: "conclusion",
    renderAfterSubmit: true,
  },
  {
    label: TabOptions.Attachments,
    path: "attachments",
    hideInSection: true,
    // renderAfterSubmit: true,
  },
  {
    label: TabOptions.Approvals,
    path: "approvals",
    hideInSection: true,
  },
];
